export default "__VITE_ASSET__0fb3475b__"